module.exports = "/images/Caylus_20ef0e.png";